import { Trans, useLingui } from '@lingui/react/macro';
import type { StripeSubscription } from 'src/api/endpoints/storeApi.types';

export function PaymentInformation({
  subscription,
}: {
  subscription?: StripeSubscription | null;
}) {
  const { t } = useLingui();
  if (!subscription) {
    return null;
  }

  switch (subscription.paymentInformation?.payment?.type) {
    case 'card':
      return (
        <>
          <div className="mb-16 flex flex-row items-center justify-between">
            <p className="m-0 text-16">
              <Trans>Payment card:</Trans>
            </p>
            <p className="m-0 text-16">{`${
              subscription.paymentInformation.payment.details?.brand ?? t`N/A`
            } *${
              subscription.paymentInformation.payment.details?.last4 ??
              t`(Not available)`
            }`}</p>
          </div>
          <div className="flex flex-row items-center justify-between">
            <p className="m-0 text-16">
              <Trans>Valid to:</Trans>
            </p>
            <p className="m-0 text-16">{`${String(
              subscription.paymentInformation.payment.details?.expireMonth
            ).padStart(2, '0')} / ${
              subscription.paymentInformation.payment.details?.expireYear ?? ''
            }`}</p>
          </div>
        </>
      );
    case 'invoice':
      return (
        <p className="m-0 text-16">
          <Trans>Paying with invoice</Trans>
        </p>
      );
    default:
      return null;
  }
}
